<template>
  <Modal
    ref="updateTrainerModal"
    :title="'Edit Model Experiment'"
    @closed="clearData"
  >
    <template #modal-main>
      <div class="settings container">
        <div class="row mb-3">
          <div class="col-12 settings__control-group">
            <label>Name</label>
            <input
              v-model="name"
              class="select"
              type="text"
            >
          </div>
        </div>
        <div class="row">
          <div class="col-12 settings__control-group">
            <label>Description</label>
            <textarea
              v-model="description"
              rows="4"
              cols="50"
            />
          </div>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="footer">
        <button class="button button-sm" @click="apply">Save</button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
  name: 'TrainerUpdateModal',
  components: {
    Modal,
  },
  props: {
    modalTrainer: {
      type: Object,
      default: () => {},
    },
  },
  emits: {
    'edit-trainer': null,
  },
  data() {
    return {
      name: '',
      description: '',
    };
  },
  watch: {
    modalTrainer(d) {
      if (d) {
        this.name = this.modalTrainer.name;
        this.description = this.modalTrainer.description;
      }
    },
  },
  methods: {
    showModal() {
      this.$refs.updateTrainerModal.showModal();
    },
    clearData() {
      this.name = "";
      this.description = "";
    },
    closeModal() {
      this.clearData();
      this.$refs.updateTrainerModal.closeModal();
    },
    apply() {
      if (this.name) {
        this.$emit('edit-trainer', { name: this.name, description: this.description, trainer_id: this.modalTrainer.id });
      }
      this.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>

.settings {
  padding: 0.75rem 3rem;
  min-width: 420px;
}

.footer {
  display: flex;
  flex-direction: row;
  padding: 0.75rem 3rem;
  justify-content: flex-end;
}

.close-button {
  @include themify() {
    background: themed('button-secondary');
    color: themed('button-secondary-text');
  }
}
</style>
